export default "__VITE_ASSET__ceab8ba0__"